export default __webpack_public_path__ + "static/media/image-9.09ff0fd7.png";